export default __webpack_public_path__ + "static/media/MongoDB.8fdc00b4.jpg";